export enum TableOfContentFeaturesEnum {
    HEADLINES = 'HEADLINES',
    MENTION_COUNT = 'MENTION_COUNT',
    MENTION_SECTIONS = 'MENTION_SECTIONS',
    TITLES = 'TITLES',
}
